<div class="modal-main">
  <div
    class="header d-flex justify-content-center align-items-center position-relative pt-3 pb-3 px-4"
  >
    <h1 class="modal-title mb-0">{{ "DELETE_ACCOUNT" | translate }}</h1>
    <img
      src="/assets/svg/ico-hamburger-close.svg"
      class="cross-button position-absolute pointer-cursor"
      (click)="closeDialog()"
    />
  </div>

  <div class="content px-4 pt-4">
    <h2 class="confirm-title">{{ "CONFIRM_ACCOUNT_DELETION" | translate }}</h2>

    <ul class="confirm-list">
      <li>{{ "DELETE_ACCOUNT_WARNING_1" | translate }}</li>
      <li>{{ "DELETE_ACCOUNT_WARNING_2" | translate }}</li>
      <li>
        {{ "DELETE_ACCOUNT_WARNING_3_PREFIX" | translate }}
        <strong>{{ "CANCEL" | translate | titlecase }}</strong>
        {{ "DELETE_ACCOUNT_WARNING_3_SUFFIX" | translate }}
      </li>
    </ul>

    <div class="button-container mt-4">
      <button class="btn-delete" (click)="confirmDelete()">
        {{ "DELETE_ACCOUNT" | translate | uppercase }}
      </button>
      <button class="btn-cancel mt-3" (click)="cancel()">
        {{ "CANCEL" | translate | uppercase }}
      </button>
    </div>
  </div>
</div>
